import React from 'react';
import { Helmet } from 'react-helmet';
import useContext from '../../hooks/useContext';
import { SiteContext } from '../../SiteContext';

const createMetaKey = (props: Record<string, string>) =>
  Object.keys(props).reduce((key, acc) => acc + `${key}:${props[key]}`, '');

const Head = () => {
  const {
    data: { canonical, meta },
  } = useContext(SiteContext);

  return (
    // @ts-ignore - We can resolve this when we update the dependencies/types
    <Helmet>
      <title>{meta?.title}</title>
      <link rel="canonical" href={canonical} />
      {meta?.description && <meta name="description" content={meta?.description} />}
      {meta?.og?.map(({ property, content }) => (
        <meta property={property} content={content} key={property} />
      ))}
      {!!meta?.tags && meta.tags.map((props) => <meta key={createMetaKey(props)} {...props} />)}
    </Helmet>
  );
};

export default Head;
